module.exports = __webpack_public_path__ + "static/media/LogoMEIPresval_DrawerBottom.82cbebcb.svg";